import { render, staticRenderFns } from "./ProgramSummaryCard.vue?vue&type=template&id=c98ca364"
import script from "./ProgramSummaryCard.vue?vue&type=script&lang=js"
export * from "./ProgramSummaryCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports